import { request } from "utils/api";

// virtual session stats schema
export interface VirtualSessionStats {
    averageTimeWatchedSeconds: number,
    connectionShares: {
        after30s: number,
        after5min: number,
    },
    numConnectionStarts: number,
    numMaxViewers: number,
    numPlaybackStarts: number,
    numUniquePlaybackViewers: number,
    numUniqueViewers: number,
    reactions: { [reaction: string]: number },
}

// fetch virtual session stats (GET /virtual-sessions/stats)
export const getVirtualSessionStats = (data: {
    bookingId?: string,
    storyId?: string,
}) => request<VirtualSessionStats>({
    data,
    endpoint: "/virtual-sessions/stats",
    method: "get",
});
